import { useEffect } from 'react';
import Button from 'core/buttons/Button';
import { compose } from '@reduxjs/toolkit';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import withRole from 'hoc/withRole';
import Error from 'core/errors/Error';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';
import LicensingPartner from 'components/LicensingPartner/LicensingPartner';

import acl from 'app/config/acl';
import { buildRoute } from 'routes';
import { resetGetLicensingPartnerFailure } from 'app/features/licensing-partners/licensingPartnerSlice';

function ViewLicensingPartner({ isNetworkError }) {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isError, errorCode, errorMessage } = useSelector((state) => state.licensingPartners.show);

  useEffect(() => {
    if (isError) dispatch(resetGetLicensingPartnerFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode || 0}
        message={errorMessage}
        onRetry={() => dispatch(resetGetLicensingPartnerFailure())}
      />
    );

  return (
    <PageContent
      title="Licensing Partner Details"
      rightTopEndContent={
        <Button
          onClick={() =>
            navigate(buildRoute('licensing-partners.update', params.licensingPartnerId))
          }
          color="primary"
          startIcon={<EditIcon />}
        >
          Edit Licensing Partner
        </Button>
      }
    >
      <LicensingPartner licensingPartnerId={params.licensingPartnerId} />
    </PageContent>
  );
}

export default compose(withAppState, withRole([acl.SUPERADMIN, acl.ADMIN]))(ViewLicensingPartner);
